var keys = require('./keys');
var createAssigner = require('./createAssigner');
exports = createAssigner(keys);

module.exports = exports;
